import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getVacancies,
  getVacancyById,
  createVacancy,
  updateVacancy,
  removeVacancy,
} from "../repositories/vacancyRepository";

const vacancyService = {
  // API sahifani 0 dan sanaydi, interfeys esa 1 dan.
  getVacancies: async ({ currentPage, pageSize }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    return await getVacancies({
      page: Number(pageNumber) - 1,
      size: itemsPerPage,
      sort: "orderIndex",
    });
  },

  getVacancyById: async (id) => await getVacancyById(id),

  createVacancy: async (body) => await createVacancy(body),

  updateVacancy: async (id, body) => await updateVacancy(id, body),

  removeVacancy: async (id) => await removeVacancy(id),
};

export default vacancyService;
